/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import isArray from 'lodash/isArray';
import sum from 'lodash/sum';

const fileUrl = {
  attachmentHost: '',
  upload: 'upload',
  uploadMultiple: 'upload/multiple/file',
};

const MAX_FILE_NAME = 20;

const getFileUrl = (fileName) => {
  return fileName ? fileUrl.attachmentHost + fileName : '#';
};

const getResponseFile = (file, type = 'name') => {
  const fileArr = (file || '').split('/') || [];
  if (type === 'path') {
    return fileArr[0];
  }
  return fileArr[1];
};

const getResponseFileInfo = (data = {}) => {
  const {
    name = '',
    url = '',
    mineType = '',
    res: { size = 0 },
  } = data;

  // Example: 202/9914add5-261a-4c50-9918-ff12773ae841,example-10.png
  const fileArr = (name || '').split('/') || [];
  const [filePath = '', fileName = ''] = fileArr;

  // Example: 9914add5-261a-4c50-9918-ff12773ae841,example-10.png
  const realFileNameArr = (fileName || '').split(',') || [];
  const [tmpFileName = '', realFileName = ''] = realFileNameArr;

  return {
    fileName,
    filePath,
    name: realFileName,
    tmpFileName,
    url,
    fileType: mineType,
    fileSize: size,
  };
};

/**
 * Get multiple file mapping function
 * @param {*} fileMap example at: mock/fileMapping.json
 * @param {*} files This is response data of api /upload/multiple/file
 * you can take a look example at: mock/files.json
 * If will return new File Mapping by adding 'files' attr next to 'fileNames' attr
 * This 'files' attr will contain array of string, each item is 'File Name Custom'
 * This 'File Name Custom' will contain fileName and filePath, split by '/,'
 * So when you use split('/,'). You will get fileName is [0] and filePath is [1]
 */
const getMultipleFileMapping = (fileMap = [], files = []) => {
  const fileMapping = [...fileMap];
  let res = [];

  if (files && typeof files === 'object') {
    // response as array when multiple files uploaded
    if (isArray(files)) res = [...files];
    // response as object when only 1 file uploaded
    else res = [files];
  }

  res.map((f) => {
    // current 'name' attr from response "4492/1a3fbbe9-3e82-4c3a-c5b9-a30d31b8066d,image6.png"
    // So split(',')[1] is original file name
    const fileNameArr = (f.name || '').split('/') || [];
    const fileName = (fileNameArr[1] || '').split(',')[1];
    const tmpFileName = `${fileNameArr[1]}/,${fileNameArr[0]}`;

    fileMapping.map((fm, index) => {
      if (
        isArray(fm.fileNames) &&
        fileMapping[index].fileNames.includes(fileName) &&
        (fileMapping[index].files || []).length < fileMapping[index].fileNames.length
      ) {
        fileMapping[index].files = [...(fileMapping[index].files || []), ...[tmpFileName]];
      } else if (isArray(fm.files)) {
        fm.files.map((fmf, fmfIndex) => {
          if (
            isArray(fmf.fileNames) &&
            fmf.fileNames.includes(fileName) &&
            (fileMapping[index].files[fmfIndex].files || []).length < fmf.fileNames.length
          ) {
            fileMapping[index].files[fmfIndex].files = [
              ...(fileMapping[index].files[fmfIndex].files || []),
              ...[tmpFileName],
            ];
          }
          return true;
        });
      }
      return true;
    });
    return true;
  });

  return fileMapping;
};

const getMultipleFileInfoMapping = (fileMap = [], files = []) => {
  const fileMapping = [...fileMap];
  let res = [];

  if (files && typeof files === 'object') {
    // response as array when multiple files uploaded
    if (isArray(files)) res = [...files];
    // response as object when only 1 file uploaded
    else res = [files];
  }

  res.forEach((f) => {
    const tmpFileInfo = getResponseFileInfo(f); // { fileName, filePath, name, tmpFileName, url }
    const { name: fileName = '' } = tmpFileInfo;

    fileMapping.forEach((fm) => {
      if (
        isArray(fm.fileNames) &&
        fm.fileNames.includes(fileName) &&
        (fm.files || []).length < fm.fileNames.length
      ) {
        fm.files = [...(fm.files || []), ...[tmpFileInfo]];
      } else if (isArray(fm.files)) {
        fm.files.forEach((fmf) => {
          if (
            isArray(fmf.fileNames) &&
            fmf.fileNames.includes(fileName) &&
            (fmf.files || []).length < fmf.fileNames.length
          ) {
            fmf.files = [...(fmf.files || []), ...[tmpFileInfo]];
          }
        });
      }
    });
  });

  return fileMapping;
};

const getFileNameAndExtension = (fileName) => {
  const lastDot = fileName.lastIndexOf('.');
  const name = fileName.substring(0, lastDot);
  const extension = fileName.substring(lastDot + 1);

  return [name, extension];
};

const getFileNameDisplay = (fileName, size = MAX_FILE_NAME) => {
  if (!fileName) return;

  const [name, extension] = getFileNameAndExtension(fileName);

  let result = fileName;

  if (name.length > size) {
    const middle = Math.floor(size / 2);
    result = `${name.substring(0, middle)}...${name.substring(
      name.length - middle,
      name.length
    )}.${extension}`;
  }

  return result;
};

const openFileURL = (url) => {
  if (url) window.open(url, '_blank');
};

const openFileFromData = (currentFileUrl) => {
  const el = document.createElement('iframe');
  el.src = currentFileUrl;
  el.style.width = '100%';
  el.style.height = '100%';
  const win = window.open('', '_blank');
  win.document.write(el.outerHTML);
  win.focus();
};

const getFilesWithFormatName = (files) => {
  let isSingleFile = false;
  let res = [];
  if (files && typeof files === 'object') {
    // response as array when multiple files uploaded
    if (isArray(files)) res = [...files];
    // response as object when only 1 file uploaded
    else {
      isSingleFile = true;
      res = [files];
    }
  }

  res = res
    .filter((f) => !f.fileName)
    .map((file) => {
      const [name, extension] = getFileNameAndExtension(file.name);
      // replace fileName has space+special character (except dash - and underscore _) by empty character
      const formatName = (name || '').replace(/[^\w-_]+/g, '');

      const blob = file.slice(0, file.size, file.type);

      // eslint-disable-next-line no-undef
      // const newFile = new File([blob], `${formatName}.${extension}`, { type: file.type });
      const newFile = new Blob([blob], { type: file.type });

      newFile.name = `${formatName}.${extension}`;

      return newFile;
    });

  return isSingleFile && res.length === 1 ? res[0] : res;
};
const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const buildHierarchical = (rootId, data, initialNode = {}) => {
  let rootNode = { ...initialNode };
  if (!data.length) return {};
  const children = data.filter(({ parentId }) => (parentId || 0) === rootId);
  if (!children.length) return {};

  const files = children.filter(({ url }) => !!url);
  const folders = children.filter(({ url }) => !url);
  rootNode = {
    ...rootNode,
    [rootId]: {
      files,
      folders: {},
      size: sum(files.map(({ size }) => +size || 0)),
      totalFiles: files,
      totalFolders: folders,
    },
  };
  if (folders.length) {
    folders.forEach((folder) => {
      const nodes = buildHierarchical(folder.id, data);
      rootNode[rootId].folders[folder.id] = { ...nodes[folder.id], ...folder };
      rootNode[rootId].totalFiles = (rootNode[rootId]?.totalFiles || []).concat(
        rootNode[rootId].folders[folder.id]?.totalFiles || []
      );
      rootNode[rootId].totalFolders = (rootNode[rootId]?.totalFolders || []).concat(
        rootNode[rootId].folders[folder.id]?.totalFolders || []
      );
      rootNode[rootId].size =
        rootNode[rootId]?.size + (rootNode[rootId].folders[folder.id]?.size || 0);
    });
  }
  return rootNode;
};

export {
  formatBytes,
  getFileUrl,
  getResponseFile,
  getResponseFileInfo,
  getMultipleFileMapping,
  getMultipleFileInfoMapping,
  getFileNameAndExtension,
  getFileNameDisplay,
  openFileURL,
  openFileFromData,
  getFilesWithFormatName,
  buildHierarchical,
};
